const escape = (text: string) => {
  return text
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,");
};

export const writeToString = (rows, delimiter = ',') => {
  return rows.map(row => {
    return row.map(value => {
      return isNaN(value) ? escape(value) : value;
    }).join(delimiter);
  }).join('\n');
};
